import { ApiResponse } from 'apisauce';
import { restApi } from '../../services/api';
import { TeceoApiResponse } from '../../types/request.types';
import {
  CreateUser,
  CreateUserContextPayload,
  ListUserContextDTO,
} from './types/createAccount.types';

export const signUpRepository = () => ({
  createAccount: (
    data: CreateUser,
  ): Promise<ApiResponse<any, { data: boolean; message: string }>> =>
    restApi.post('stores/sign-up', data),
  createUserContext: (
    data: CreateUserContextPayload,
  ): Promise<TeceoApiResponse<ListUserContextDTO>> =>
    restApi.post('stores/sign-up-existent-user', data),
});
